import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import actions from '../constants';
import DatasetNotificationCreateToast from '../components/DatasetNotificationCreateToast';

export function* createDatasetNotificationToast({ name }) {
  yield call(showToast, <DatasetNotificationCreateToast name={name} />);
}

export default function* datasetNotificationToasts() {
  yield takeEvery(actions.CREATE_DATASET_NOTIFICATION_SUCCESS, createDatasetNotificationToast);
}
